
export default {
    name: 'historique-imagerie-medicale',
    components: {
        
    },
    props: {
        historique: Object
    },

    data() {
        return {
            demande_examen: {}
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        viewResult(demande_examen) {
            const param_result = {
                demande_examen: demande_examen,
                evolution_id: this.historique.evolution_id
            }
            this.$emit('emitViewResultImagerie', param_result)
        }
    }
}


